import React, { FC } from "react";
import { CircularProgress, Modal } from "@mui/material";
import colors from "../theme/Colours";

type LoaderProps = {
  show: boolean;
};

const Loader: FC<LoaderProps> = ({ show }) => {
  return (
    <Modal
      hideBackdrop
      open={show}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <>
        {/* DO NOT REMOVE THE FRAGMENT "<></>" */}
        <CircularProgress sx={{ color: colors.breadcrumbActiveColor }} />
      </>
    </Modal>
  );
};

export default Loader;
